export function mountEngagement(tracker) {
	let lastTick = performance.now(), lastInteraction = lastTick, seconds = 0;
	let path = location.pathname, title = document.title, finished = false;
	let wasVisible = !document.hidden;
	const milestones = new Set();
	const sample = () => {
		const now = performance.now();
		if (wasVisible && lastTick - lastInteraction < 60000) seconds += Math.min(now - lastTick, 15000) / 1000;
		wasVisible = !document.hidden;
		lastTick = now;
	};
	const checkpoint = (exit = false) => {
		sample();
		if (finished) return;
		if (seconds > 0 || exit) {
			tracker.track(exit ? "page_exit" : "engagement", exit ? "Page Exit" : "Active engagement", "page", {
				page_url: path, page_title: title, time_on_page: Math.round(seconds * 100) / 100,
				scroll_depth: tracker.maxScrollDepth, exit_page: exit ? path : "",
				metadata: { measurement: "active_time_delta" },
			});
			seconds = 0;
		}
		tracker.flush(true);
		finished = exit;
	};
	tracker.finishPage = () => { checkpoint(true); finished = false; path = location.pathname; title = document.title; milestones.clear(); };
	setInterval(() => checkpoint(), 15000);
	["pointerdown", "pointermove", "keydown", "touchstart", "scroll"].forEach(type => window.addEventListener(type, () => {
		sample(); lastInteraction = performance.now();
	}, { passive: true }));
	document.addEventListener("visibilitychange", () => {
		if (document.hidden) checkpoint();
		else { wasVisible = true; lastTick = performance.now(); lastInteraction = lastTick; }
	});
	window.addEventListener("pagehide", () => checkpoint(true));
	window.addEventListener("pageshow", event => {
		if (event.persisted) { finished = false; lastTick = performance.now(); tracker.trackPageView(); }
	});
	window.addEventListener("scroll", () => {
		[25, 50, 75, 90].forEach(depth => {
			if (tracker.maxScrollDepth >= depth && !milestones.has(depth)) {
				milestones.add(depth);
				tracker.track("scroll", `Scrolled ${depth}%`, "engagement", { scroll_depth: depth });
			}
		});
	}, { passive: true });
	document.addEventListener("solufy:form-result", event => {
		const { form, success } = event.detail;
		tracker.track(success ? "form_success" : "form_error", success ? "Enquiry received" : "Enquiry failed", "forms", {
			form_name: form.id || form.getAttribute("name") || "Website form", form_status: success ? "success" : "error",
		}, true);
	});
}
